import { Cookies } from 'react-cookie';
import { get } from 'lodash';
import config from 'config';
import Platform from 'platform';
import requester from 'utils/requester';
import api from 'config/api';
import { getCurrentLangVoliaAPICode } from 'constants/languages';

export const LOGIN_TYPES = {
  phone: 'MSISDN',
  email: 'login',
  contract: 'externalRef',
  token: 'token',
  code: 'code',
};

export const LOGIN_ERROR_CODES = {
  PHONE_SEVERAL_CONTRACTS: 'pn-is-registered-by-several-contr',
  EMAIL_SEVERAL_CONTRACTS: 'em-is-registered-by-several-contr',
};

export const RESTORE_ERROR_CODES = {
  PHONE_SEVERAL_CONTRACTS: 'passwordrecovery_error_4',
  EMAIL_SEVERAL_CONTRACTS: 'passwordrecovery_error_2',
};

const EMAIL_REG_EXP = /\S+@\S+\.\S+/;

const PHONE_REG_EXP = /\d+/;

const NINETY_DAYS_IN_SECONDS = 60 * 60 * 24 * 90;

export const isValidLoginType = (type) => !!LOGIN_TYPES[type];

export const collectLoginFormData = ({ login, password, loginType }) => {
  const formData = new FormData();

  formData.append('username', login);
  formData.append('password', password);
  formData.append('language', getCurrentLangVoliaAPICode());
  formData.append('loginType', LOGIN_TYPES[loginType]);
  return formData;
};

export const getPlatformParams = () => {
  return {
    uuid: Platform.getUID(),
    type: Platform.getDeviceType(),
    model: Platform.getModelName(),
    firmwareVersion: Platform.getFirmwareVersion(),
    appVersion: config.appVersion,
    brand: Platform.getBrand(),
    platform: Platform.getName(),
    platformVersion: Platform.getPlatformVersion(),
  };
};

/*
 * Тут дел в том, что бекенд Воли не умеет синхронизировать свои инстансы
 * и для них нужно выполнить еще одну авторизацию
 * https://hootko.atlassian.net/browse/STVWL-67
 */
export const voliaExtraLogin = async (activationCode) => {
  let token = new Cookies().get('auto-provision-token');

  // Токен живёт 90 дней, поэтому кейс с автопровиженом возможен только если юзер включил телек через 90 дней
  // Для всех остальных случаев нужно просто перелогинить существующий токен
  if (!token || activationCode) {
    const responseToken = await getAutoProvisionToken(activationCode);
    token = responseToken.token;
  }

  const data = await loginWithToken(token);
  // Токен в куках нужен для последующих запусков приложения
  setAutoProvisionTokenCookies(token);

  return data;
};

export const loginWithToken = (token) => {
  return requester({
    method: 'post',
    url: `${api.host}${api.endpoints.login}`,
    appendParams: false,
    data: collectLoginFormData({
      login: token,
      password: '1',
      loginType: 'token',
    }),
  });
};

export const getAutoProvisionToken = (activationCode) => {
  const data = getPlatformParams();

  if (activationCode) Object.assign(data, { activationCode });

  return requester({
    method: 'post',
    url: `${api.host}${api.endpoints.autoProvision}`,
    appendParams: false,
    extendHeadersWithSession: false,
    data,
  });
};

export const setAutoProvisionTokenCookies = (token) => {
  const cookies = new Cookies();
  cookies.set('auto-provision-token', token, {
    path: '/',
    maxAge: NINETY_DAYS_IN_SECONDS,
  });
};

export const resetLoginCookies = () => {
  const cookies = new Cookies();
  cookies.remove('auto-provision-token');
  // Эти куки сам requester ставит при входе в приложение
  cookies.remove('x-session-id');
};

/**
 * Эксперементальная функция, что парсит ответ от бэкенда,
 * достает оттуда заголовок, описание и значение, что было передано как логин
 * @param {string} message - оригинальное с бэкена
 */
export const parseLoginErrorMessage = (message = '') => {
  const [title, ...descriptionArr] = message.split('.');
  // нужно собрать обратно в строку и вернуть точки, что "сьел" split
  const description = descriptionArr.join('.');
  const loginValue = get(description.match(EMAIL_REG_EXP) || description.match(PHONE_REG_EXP), [0], '');
  return {
    title: title + '.',
    description,
    loginValue,
  };
};

/**
 * Еще одна сперементальная функция, что парсит другой ответ от бэкенда :)
 * Достает логин значение, чтобы его можно было выделить на странице
 * @param {string} text - оригинальное с бэкена
 */
export const parseRestorePasswordErrorMessage = (text = '') => ({
  text,
  loginValue: get(text.match(EMAIL_REG_EXP) || text.match(PHONE_REG_EXP), [0], ''),
});

export const isSeveralAccoustsError = (errorCode) => {
  return [
    LOGIN_ERROR_CODES.PHONE_SEVERAL_CONTRACTS,
    LOGIN_ERROR_CODES.EMAIL_SEVERAL_CONTRACTS,
    RESTORE_ERROR_CODES.PHONE_SEVERAL_CONTRACTS,
    RESTORE_ERROR_CODES.EMAIL_SEVERAL_CONTRACTS,
  ].includes(errorCode);
};

export const isExpiredError = (error) => {
  return [
    'passwordrecovery_error_no_otp_found',
    'passwordrecovery_error_expired_otp',
    'passwordrecovery_error_opt_to_many_attempts',
    'passwordrecovery_error_wrong_otp',
  ].includes(error.code);
};
